module.exports = __webpack_public_path__ + "static/media/ui_ux_design.d6363089.svg";